import React from "react";
import { useNavigate } from "react-router-dom";
import LandingHeader from "../../header/LandingHeader";
import AppHeader from "../../header/AppHeader";
import heroImage from "../../../assets/hero.webp";

const Hero = () => {
  const navigate = useNavigate();

  // A logged-in visitor can reach the landing page (e.g. via the app-header
  // logo) and should keep their app navigation instead of the guest header.
  // Auth is detected the same way route guards do in App.js.
  const isAdmin = !!localStorage.getItem("adminToken");
  const isCa = !!localStorage.getItem("token");
  const isLoggedIn = isCa || isAdmin;

  return (
    <section
      className="relative h-screen overflow-hidden bg-cover bg-center bg-no-repeat max-md:h-auto max-md:min-h-[100dvh] max-md:bg-right"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      {isCa ? (
        <AppHeader />
      ) : isAdmin ? (
        <AppHeader admin />
      ) : (
        <LandingHeader />
      )}

      <div className="h-[calc(100vh-90px)] flex items-center translate-y-[40px] max-md:h-auto max-md:min-h-[calc(100dvh-72px)] max-md:translate-y-0 max-md:py-10">
        <div className="w-full px-20 max-xl:px-12 max-lg:px-10 max-md:px-6 max-sm:px-5">
          {/* Status */}
          <div className="flex items-center gap-2 mb-6 max-sm:mb-4">
            <div className="w-2 h-2 rounded-full bg-green-400" />
            <p className="font-montserrat uppercase tracking-[3px] text-sm text-white max-sm:text-[11px] max-sm:tracking-[2px]">
              Available For Registration
            </p>
          </div>

          {/* Core Layout Grid/Flex Box */}
          <div className="flex items-end gap-12 max-w-[1300px] relative max-xl:flex-col max-xl:items-start max-xl:gap-5">
            
            {/* 1. Heading Block — Set to order first on mobile responsive states */}
            <div className="max-w-[900px] max-xl:max-w-full max-xl:order-1">
              <h1 className="font-barlow font-semibold text-[120px] leading-[120px] tracking-[-3px] text-white mb-10 w-full h-auto overflow-visible max-xl:text-[84px] max-xl:leading-[86px] max-lg:text-[64px] max-lg:leading-[66px] max-lg:mb-6 max-md:text-[48px] max-md:leading-[50px] max-md:tracking-[-1.5px] max-sm:text-[34px] max-sm:leading-[36px] max-sm:tracking-[-1px] max-sm:mb-4">
                Campus <br /> Ambassador Program <br /> Spirit'26
              </h1>
            </div>

            {/* Unified Structural Desktop Content Block */}
            {/* Anchored absolutely on desktop at top-[270px], but handles internal spacing fluidly */}
            <div className="xl:absolute xl:left-0 xl:top-[270px] xl:w-full flex flex-col max-xl:static max-xl:w-full max-xl:contents">
              
              {/* 2. Description Block */}
              <div className="xl:absolute xl:left-[28%] xl:top-0 w-[400px] max-xl:static max-xl:left-auto max-xl:top-auto max-xl:w-full max-xl:max-w-[460px] max-xl:order-2">
                <p className="text-white font-montserrat text-[20px] leading-[26px] max-md:text-[16px] max-md:leading-[22px]">
                  With the vision to bring out the leader in you, IIT Guwahati
                  Spirit presents the Campus Ambassador Program.
                </p>
              </div>

              {/* 3. Register Action Block */}
              {/* Uses a top margin relative to the elements above, dynamically adapting on desktop sizes */}
              {/* Hidden for logged-in users — registration is only for guests. */}
              {!isLoggedIn && (
              <div className="xl:mt-20 z-10 max-xl:order-3">
                <button
                  onClick={() => navigate("/signup")}
                  className="
                    relative
                    group
                    mt-8
                    max-xl:mt-4
                    bg-white
                    text-black
                    hover:text-white
                    px-6
                    py-3
                    flex
                    items-center
                    justify-center
                    gap-2
                    font-semibold
                    active:scale-95
                    transition-all
                    duration-300
                    overflow-hidden
                    cursor-pointer
                  "
                >
                  {/* Keep text and arrow above sliding layers */}
                  <div className="relative z-40 flex items-center gap-2">
                    <span className="font-montserrat">Register</span>
                    <span
                      className="
                        font-montserrat
                        transition-transform
                        duration-400
                        ease-out
                        group-hover:translate-x-2
                      "
                    >
                      →
                    </span>
                  </div>

                  {/* 1. GREEN LAYER (Bottom) */}
                  <span
                    aria-hidden="true"
                    className="line-green absolute inset-0 bg-[#727d1f] z-10 transform scale-x-0 origin-right transition-transform ease-out group-hover:origin-left group-hover:scale-x-100"
                  />

                  {/* 2. ORANGE LAYER (Middle) */}
                  <span
                    aria-hidden="true"
                    className="line-orange absolute inset-0 bg-[#CC5E15] z-20 transform scale-x-0 origin-right transition-transform ease-out group-hover:origin-left group-hover:scale-x-100"
                  />

                  {/* 3. MAIN BLUE LAYER (Top) */}
                  <span
                    aria-hidden="true"
                    className="line-blue absolute inset-0 bg-[#019D9D] z-30 transform scale-x-0 origin-right transition-transform ease-out group-hover:origin-left group-hover:scale-x-100"
                  />
                </button>
              </div>
              )}

            </div>

          </div>
        </div>
      </div>

    </section>
  );
};

export default Hero;